import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import PropTypes from "prop-types";

export default function VerifyEmail({
  user,
  // password,
  loginState,
  onVerified,
}) {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [otpGenerated, setOtpGenerated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const generateOtp = async () => {
      try {
        const response = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "/api/auth/generate-otp",
          { user, loginState },
          { withCredentials: true }
        );
        if (response.data.success) {
          toast.success("OTP sent to your email!", { position: "top-right" });

          setOtpGenerated(true);
        } else {
          toast.error("Failed to send OTP.", { position: "top-right" });
        }
      } catch (error) {
        toast.error("Error generating OTP! Please try again.");

        console.error("Error generating OTP: ", error);
      }
    };

    if (!otpGenerated) {
      generateOtp();
    }
  }, [otpGenerated, loginState, user]);

  const handleInputChange = (e, index) => {
    const value = e.target.value;

    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < otp.length - 1) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();

    try {
      const fullOtp = otp.join("");
      console.log("Sending OTP for verification: ", fullOtp);

      const payload = {
        user,
        userOtp: fullOtp,
        loginState,
      };

      if (location.pathname === "/login") {
        payload.currentPath = "/login";
      }

      const response = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "/api/auth/verify-otp",
        payload,
        { withCredentials: true }
      );

      console.log("OTP Verification Response: ", response.data);
      toast.success("OTP verified successfully!");

      console.log("loginState inside verify email: ", response.data.loginState);

      onVerified(response.data.loginState || "default login state");
    } catch (error) {
      console.error("Verification error: ", error);
      toast.error("Verification failed! Please try again.");
    }
  };

  const handleResendOTP = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "/api/auth/generate-otp",
        { user, loginState },
        { withCredentials: true }
      );
      if (response.data.success) {
        toast.success("OTP resent!", { position: "top-right" });
        setOtp(Array(6).fill(""));
        setOtpGenerated(false);
      } else {
        toast.error("Failed to resend OTP.", { position: "top-right" });
      }
    } catch (error) {
      toast.error("Resend OTP failed! Please try again.", {
        position: "top-right",
      });
      console.error("Resend OTP error:", error);
    }
  };

  return (
    <div className="verify-email">
      <h2 className="text-2xl font-bold mb-4">Verify Your Email Address</h2>
      <p className="text-gray-600 mb-4">
        A verification code has been sent to <strong>{user.username}</strong>.
      </p>
      <p className="text-gray-500 mb-6">
        Please check your inbox and enter the verification code below to verify
        your email address.
      </p>
      <form onSubmit={handleVerifyOTP}>
        <div className="flex justify-center gap-2 mb-6">
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-input-${index}`}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleInputChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="w-12 h-12 text-center border border-gray-300 rounded-md focus:ring focus:ring-green-300 text-xl"
            />
          ))}
        </div>
        <button
          type="submit"
          className="w-full bg-green-500 text-white py-2 rounded-md hover:bg-green-600"
        >
          Verify Email
        </button>
      </form>
      <div className="flex justify-between mt-4">
        <button onClick={handleResendOTP} className="text-blue-500 underline">
          Resend code
        </button>
        <button
          onClick={() => toast.info("Change Email", { position: "top-right" })}
          className="text-blue-500 underline"
        >
          Change email
        </button>
      </div>
    </div>
  );
}

VerifyEmail.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string.isRequired,
  }).isRequired,
  // password: PropTypes.string.isRequired,
  loginState: PropTypes.string.isRequired,
  onVerified: PropTypes.func.isRequired,
};
